import { Loader } from '@octopus-do/octopus-storybook'
import { ArrowDown } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  loading: boolean
  onClick: () => void
}

export const LoadMoreButton: React.FC<Props> = ({ loading, onClick }) => (
  <button
    className={clsJoin(css.load_more_button, loading && css.loading)}
    onClick={loading ? undefined : onClick}
  >
    {!loading && (
      <div className={css.button_inner}>
        <ArrowDown />
        Show 50 more
      </div>
    )}

    {loading && <Loader color="gray" threeDots />}
  </button>
)
